import React, { Component } from "react";
import { Link } from "react-router-dom";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";

import Cookies from "universal-cookie";
const cookies = new Cookies();
//cookies.get('key') === "3fcfa1d9178290b9fc5404c6603b96ab"

class Introduction extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      bPayed: cookies.get("key") === "3fcfa1d9178290b9fc5404c6603b96ab",
    };
  }

  render() {
    const style = {
      margin: {
        margin: "20px",
        marginTop: "30px",
      },
    };

    const showButton = this.state.bPayed ? (
      <Link to={"/keywords-rules"}>
        <Button variant="raised" style={style.margin} color="primary">
          Start to play
        </Button>
      </Link>
    ) : (
      <a href="https://showyourtruecolours.nl/show-your-sustainable-colours-app/">
        <Button variant="raised" style={style.margin} color="primary">
          Pay & Enter
        </Button>
      </a>
    );

    const bold = {
      fontWeight: "900",
    };

    return (
      <section>
        <div>
          <div className="container">
            <Typography variant="headline" style={{ fontSize: "35px" }}>
              Introduction
            </Typography>
            <Typography
              component="div"
              style={{
                margin: "20px",
                textAlign: "left",
                fontWeight: "lighter",
              }}
            >
              <span style={bold}>HOW:</span>{" "}
              <div className="intro-text">
                you can play the game individually and share the outcome with
                friends
                <br />
              </div>
              <span style={bold}>WHY:</span>{" "}
              <div className="intro-text">
                One discovers in a playful way from three different perspectives
                of his /her personal talents related to the Earth Charter and
                SDG’s. Additionally, a personal sustainable challenge focus will
                be chosen.
                <br />
              </div>
            </Typography>
            <Typography
              component="div"
              style={{
                margin: "20px",
                textAlign: "left",
                fontWeight: "lighter",
              }}
            >
              This digital game can be used individually within teams and
              coaching. This leads to insights into the applicability of the
              principles of the Earth Charter and the SDGs.
              <br />
              <br />
              Links to specific articles of the Earth charter and specific SDG’s
              which are related to the participants talents are provided.
              <br />
              <br />
              <h3>INSTRUCTION</h3>
              <br />
              Your are about to start a questionnaire that will result in
              receiving a personal report that will help you identify your
              natural skills and potential targeting a sustainable environment.
              The inventory consists of 4 components that will take you 15
              minutes to run through. Don’t linger to long at each question but
              follow your first inspiration.
              <br />
              <br />
              In order to receive the end result yourself and to share it with
              others you have to fill in your mail address and that of your
              colleagues / friends. Enjoy your first steps into insight in your
              contribution to climate change and a sustainable world.
            </Typography>

            {showButton}
          </div>
        </div>
      </section>
    );
  }
}

export default Introduction;



// WEBPACK FOOTER //
// ./src/views/IntroductionView.jsx